import { supabase } from "./supabase.js";

/**
 * Send a quote or invoice through the send-doc Edge Function.
 *
 * The document text is rendered here, by the same buildInvoiceEmail the print
 * view uses, so the emailed and printed versions cannot disagree. The function
 * decides the recipient from the database — see its header for why.
 */
export async function sendDoc({ rentalId, kind, subject, body, attachment }) {
  const { data, error } = await supabase.functions.invoke("send-doc", {
    body: { rentalId, kind, subject, body, attachment },
  });

  if (error) {
    // invoke() reports a non-2xx as a generic FunctionsHttpError, so dig the
    // real message out of the response — "Email provider refused the message"
    // is actionable, "Edge Function returned a non-2xx status code" is not.
    let detail = error.message;
    try {
      const parsed = await error.context?.json?.();
      if (parsed?.error) detail = parsed.error;
    } catch { /* keep the generic message */ }

    if (/not found|does not exist|Failed to send a request/i.test(detail)) {
      detail =
        "Email is not set up yet — the send-doc function has not been deployed. " +
        "See PHASE-4-EMAIL.md. Until then, use “Copy text” and paste into your email app.";
    }
    throw new Error(detail);
  }

  if (data?.error) throw new Error(data.error);
  return data;
}
